<div>
  <p>
    Er zijn momenteel {{ isDoubleSided ? 'niet genoeg' : 'geen' }} panelen meer
    in <strong>voorraad</strong>
    {{ isDoubleSided ? 'voor dit bordtype' : '' }} in ons magazijn.
  </p>
  <p>
    Indien u een nieuwe plaatsing wil aanvragen, dient u ofwel nieuwe borden bij
    te bestellen ofwel op 'zonder voorraad' te klikken.
  </p>

  <div class="d-flex button-container">
    <div>
      <button mat-button class="order-stock-button" (click)="orderStock()">
        Nieuwe voorraad bestellen
      </button>
    </div>
    <div>
      <img
        width="125"
        height="89"
        [src]="'/assets/client-ip-board/custombord.png'"
      />
      <button
        mat-button
        class="order-stock-button mt-2"
        (click)="selectNoStock()"
      >
        Ga door zonder voorraad
      </button>
    </div>
  </div>
  <div class="d-flex justify-content-center mt-3 ml-0">
    <button mat-button class="close-button" (click)="close()">
      Sluiten
    </button>
  </div>
</div>
